/**
 * Home Page — main home experience.
 * Standalone three-panel document processing & review UI. Full-screen layout (does not use AppLayout).
 */
import HomeApp from "@/components/home/home-app";

export default function HomePage() {
    return <HomeApp />;
}
